// Sfondi delle mappe Leaflet, uguali per tutte le mappe dell'app: dashboard, dettaglio impianto e vista dall'alto. Scelti da Angelo il 30/10/2026: **Stradale** (OpenStreetMap, è
// l'«automatica» di partenza, in entrambi i temi), la mappa fissa **Chiara** o **Scura** (Esri Canvas, quella del tema attuale) e **Satellitare** (Esri). La scelta è una sola e si
// salva nello store `ui` (`sfondoMappa`); le altre mappe (ibrida, topografica, rilievo, grigi, umanitaria) sono state tolte. Nel tema scuro la stradale si attenua con un filtro
// (`.tile-stradale` in `assets/css/vendor/leaflet.css`) perché non abbagli.
export interface LivelloTile {
  url: string;
  options: { maxZoom?: number; attribution?: string; opacity?: number; className?: string };
}

export type ChiaveBasemap = "stradale" | "chiara" | "scura" | "satellite";

export const BASEMAP_LEAFLET: Record<ChiaveBasemap, { layers: LivelloTile[] }> = {
  stradale: {
    layers: [
      {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        options: { maxZoom: 19, className: "tile-stradale", attribution: "&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors" },
      },
    ],
  },
  chiara: {
    layers: [
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        options: { maxZoom: 16, attribution: "Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ" },
      },
    ],
  },
  scura: {
    layers: [
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}",
        options: { maxZoom: 16, attribution: "Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ" },
      },
    ],
  },
  satellite: {
    layers: [
      {
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        options: {
          maxZoom: 19,
          attribution: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
        },
      },
    ],
  },
};

/** Ciò che l'utente sceglie: `auto` è la mappa stradale (di partenza), `chiara` e `scura` sono fisse. */
export type SceltaSfondo = "auto" | "chiara" | "scura" | "satellite";
export const SCELTE_SFONDO: readonly SceltaSfondo[] = ["auto", "chiara", "scura", "satellite"];
export const SCELTA_SFONDO_PREDEFINITA: SceltaSfondo = "auto";

/** Un valore qualunque (anche una chiave vecchia come «streets» o «hybrid» salvata prima del 30/10/2026) diventa una scelta valida: gli sconosciuti → `auto` (stradale). */
export function normalizzaSceltaSfondo(valore: unknown): SceltaSfondo {
  return SCELTE_SFONDO.includes(valore as SceltaSfondo) ? (valore as SceltaSfondo) : SCELTA_SFONDO_PREDEFINITA;
}

/** Lo sfondo da disegnare: «automatica» è la stradale, in entrambi i temi. */
export function sfondoRisolto(scelta: SceltaSfondo): ChiaveBasemap {
  return scelta === "auto" ? "stradale" : scelta;
}

/**
 * La voce «mappa fissa» del pannello: nel tema chiaro «Chiara», nel tema scuro «Scura». Se si è scelta la fissa dell'altro tema (e poi il tema è cambiato) la voce
 * resta quella scelta, così il pannello non mostra mai tre voci senza nessuna attiva.
 */
export function voceFissaSfondo(scelta: SceltaSfondo, temaScuro: boolean): "chiara" | "scura" {
  if (scelta === "chiara" || scelta === "scura") return scelta;
  return temaScuro ? "scura" : "chiara";
}
